import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav", "scrim"]

  declare readonly navTarget: HTMLElement
  declare readonly scrimTarget: HTMLElement

  toggle() {
    const isOpen = this.navTarget.classList.contains("is-open")
    this.navTarget.classList.toggle("is-open", !isOpen)
    this.scrimTarget.classList.toggle("is-open", !isOpen)
    document.body.style.overflow = isOpen ? "" : "hidden"
  }

  close() {
    this.navTarget.classList.remove("is-open")
    this.scrimTarget.classList.remove("is-open")
    document.body.style.overflow = ""
  }
}
